import './Historico.css';
import { useContext } from 'react';
import { OrderContext } from '../contexts/OrderContext';
import { isoToBrDate } from '../utils';

export default function Historico() {
    const orderConversations = useContext(OrderContext).conversations

    return (
        <section id="Historico-table">
            <table>
                <thead>
                    <tr className="table-header">
                        <th>Data</th>
                        <th>Status</th>
                        <th>Mensagem</th>
                    </tr>
                </thead>

                <tbody>
                    {orderConversations.map(item => (
                        <tr>
                            <td>{isoToBrDate(item.date)}</td>
                            <td>{item.subject}</td>
                            <td className='first-words'>{item.firstWords}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </section>
    )
}